// src/pages/admin/dashboard/tabs/transactions/StaffTransactions.jsx

import React, { useState } from "react";
import { adminApi } from "../../../../../services";
import TransactionTable from "../../../../../components/transactions/TransactionTable";
import TransactionSummary from "../../../../../components/transactions/TransactionSummary";

const StaffTransactions = ({ type }) => {
  const [email, setEmail] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState({ totalCredit: 0, totalDebit: 0 });

  const handleSearch = async () => {
    if (!email) return alert("Enter staff email");

    try {
      const { data } = await adminApi.getStaffTransactionsByEmail(email, type);

      const txns = data.data.map((txn) => ({
        id: txn._id,
        customer: txn.userId?.name,
        phone: txn.userId?.phone,
        accountNumber: txn.accountNumber,
        type: txn.type,
        amount: txn.amount,
        doneBy: txn.performedBy?.id?.name,
        date: txn.createdAt,
        balance: txn.newBalance,
      }));

      setTransactions(txns);

      const totalCredit = txns.filter(t => t.type === "credit").reduce((a, b) => a + b.amount, 0);
      const totalDebit = txns.filter(t => t.type === "debit").reduce((a, b) => a + b.amount, 0);

      setSummary({ totalCredit, totalDebit });

    } catch (err) {
      alert(err.response?.data?.message || "Error");
    }
  };

  return (
    <div>
      <h3>Staff Transactions ({type})</h3>

      <input
        type="email"
        placeholder="Enter staff email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="form-control mb-2"
      />

      <button className="btn btn-primary mb-3" onClick={handleSearch}>
        Search
      </button>

      <TransactionSummary summary={summary} />
      <TransactionTable transactions={transactions} />
    </div>
  );
};

export default StaffTransactions;
